import React from 'react';
import styled, { keyframes } from 'styled-components';

const shimmerAnimation = keyframes`
  0% { background-position: -200px 0; }
  100% { background-position: 200px 0; }
`;

const ShimmerWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const ShimmerItem = styled.div`
  background: #f6f7f8;
  background-image: linear-gradient(
    90deg,
    #f6f7f8 0px,
    #eaeaea 40px,
    #f6f7f8 80px
  );
  background-size: 200% 100%;
  animation: ${shimmerAnimation} 1.5s infinite linear;
  border-radius: 4px;
  margin-bottom: 1rem;
`;

const ShimmerText = styled(ShimmerItem)`
  width: 100%;
  height: 2rem;
`;

export const AboutSectionShimmerLoader: React.FC = () => {
  return (
    <ShimmerWrapper>
      <ShimmerText />
      <ShimmerText />
      <ShimmerText />
      <ShimmerText />
    </ShimmerWrapper>
  );
};
